import * as Modifiers from './modifiers';

export default {
  HIT_SCHEMA: {
    AUTOCOMPLETE: {
      cuisine: {
        _modifier: Modifiers.getFirstArrayElement,
        breadcrumbs: 'cuisine',
      },
      highlighted: {
        city: '_highlightResult.locality.value',
        cuisine: {
          _modifier: [
            {
              fn: Modifiers.getFirstArrayElement,
            },
            {
              fn: Modifiers.get,
              key: 'value',
            },
          ],
          breadcrumbs: '_highlightResult.cuisine',
        },
        neighborhood: '_highlightResult.neighborhood.value',
        state: 'region',
      },
      id: 'id.resy',
      image: {
        _modifier: Modifiers.getFirstArrayElement,
        breadcrumbs: 'images',
      },
      isGda: 'is_global_dining_access',
      isTockInventory: 'is_tock_inventory',
      tockBusinessPageUrl: 'tock_business_page_url',
      location: {
        city: 'locality',
        code: 'location.code',
        name: 'location.name',
        urlSlug: 'location.url_slug',
        neighborhood: 'neighborhood',
        state: 'region',
      },
      name: 'name',
      urlSlug: 'url_slug',
      _geoloc: '_geoloc',
    },
    SEARCH_RESULT: {
      activeNotifications: {
        _modifier: [
          {
            fn: Modifiers.arrayToDictionary,
            key: 'service_type_id',
          },
        ],
        breadcrumbs: 'availability.notifies',
      },
      availableServiceTypes: {
        _modifier: Modifiers.dictionaryToArray,
        breadcrumbs: 'availability.service_types',
      },
      collections: 'collections',
      cuisine: {
        _modifier: Modifiers.getFirstArrayElement,
        breadcrumbs: 'cuisine',
      },
      currency: 'currency_symbol',
      events: 'availability.events',
      experiences: 'availability.experiences',
      favorite: 'favorite',
      featureRecaptcha: 'feature_recaptcha',
      gdaConciergeBooking: 'gda_concierge_booking',
      id: 'id.resy',
      image: {
        _modifier: Modifiers.getFirstArrayElement,
        breadcrumbs: 'images',
      },
      isGda: 'is_global_dining_access',
      isTockInventory: 'is_tock_inventory',
      location: {
        code: 'location.code',
        name: 'location.name',
        neighborhood: 'neighborhood',
        urlSlug: 'location.url_slug',
      },
      name: 'name',
      objectID: 'objectID',
      priceRange: 'price_range_id',
      rating: {
        _modifier: Modifiers.rating,
        breadcrumbs: 'rating.average',
      },
      reopen: 'reopen',
      tockBusinessPageUrl: 'tock_business_page_url',
      tockBusinessSearchUrl: 'tock_business_search_url',
      totalRatings: 'rating.count',
      urlSlug: 'url_slug',
      whyWeLikeIt: {
        _modifier: Modifiers.getWhyWeLikeIt,
        breadcrumbs: 'content',
      },
      _geoloc: '_geoloc',
    },
  },
  NOTIFY_SCHEMA: {
    day: 'day',
    end: 'time_preferred_end',
    seats: 'num_seats',
    serviceTypeId: 'service_type_id',
    start: 'time_preferred_start',
    venueId: 'venue_id',
  },
  RESERVATION_SCHEMA: {
    attendee: 'attendee',
    bookOnBehalf: 'book_on_behalf',
    cancellation: 'cancellation',
    cancellationPolicy: 'cancellation_policy',
    change: 'change',
    content: 'content',
    currencyCode: 'currencyCode',
    day: 'day',
    event: {
      eventTypeId: 'event_type_id',
      eventUrlSlug: 'event_url_slug',
      name: 'name',
      packageName: 'package_name',
    },
    features: 'features',
    id: 'reservation_id',
    isExpired: 'rating.expired',
    isNow: {
      _modifier: Modifiers.reservationIsNow,
      breadcrumbs: 'when',
    },
    isGda: 'is_global_dining_access',
    occasion: 'occasion',
    pastOrFuture: {
      _modifier: Modifiers.pastOrFuture,
      breadcrumbs: 'when',
    },
    party: 'party',
    payment: 'payment',
    paymentMethod: 'payment_method',
    price: 'price',
    rating: 'rating.value',
    seats: 'num_seats',
    serviceCharge: 'service_charge',
    serviceTypeId: 'service_type_id',
    share: 'share',
    specialRequest: 'special_request',
    tableType: 'config.type',
    template: 'template',
    time: 'time_slot',
    token: 'resy_token',
    conciergeResyToken: 'concierge_resy_token',
    venue: {
      id: 'id',
      images: 'images',
      isGda: 'is_global_dining_access',
      isResyCreditEligible: 'is_resy_credit_eligible',
      contact: {
        phone: {
          _modifier: Modifiers.formatPhone,
          breadcrumbs: 'contact.phone_number',
        },
        url: 'contact.url',
      },
      hideAllergyQuestion: 'hide_allergy_question',
      hideOccasionQuestion: 'hide_occasion_question',
      hideSpecialRequestQuestion: 'hide_special_request_question',
      location: {
        address1: 'location.address_1',
        address2: 'location.address_2',
        city: 'location.locality',
        code: 'location.code',
        coords: {
          lat: 'location.latitude',
          long: 'location.longitude',
        },
        state: 'location.region',
        postalCode: 'location.postal_code',
        urlSlug: 'location.url_slug',
      },
      menuItems: 'menu_items',
      name: 'name',
      resySelect: 'resy_select',
      survey: 'survey',
      taxIncluded: 'tax_included',
      venueSlug: 'venue_url_slug',
    },
  },
  SLOT_SCHEMA: {
    FLY: {
      badge: 'reservation_config.badge',
      colors: 'display_config.color',
      isGda: 'is_global_dining_access',
      venueIsGda: 'venue.is_global_dining_access',
      serviceTypeId: 'shift.service.type.id',
      templateId: 'template.id',
      time: 'date.start',
      token: 'config.token',
      type: 'config.type',
      payment: 'payment',
      tockBookingUrl: 'tock_booking_url',
      allow_bypass_payment_method: 'venue.allow_bypass_payment_method',
      isEligible: 'exclusive.is_eligible',
      exclusiveId: 'exclusive.id',
      gatingErrors: 'gating_errors',
    },
    SEARCH: {
      FLY: {
        badge: 'reservation_config.badge',
        colors: 'display_config.color',
        isGda: 'is_global_dining_access',
        time: 'date.start',
        token: 'config.token',
        type: 'config.type',
        payment: 'payment',
        tockBookingUrl: 'tock_booking_url',
        allow_bypass_payment_method: 'venue.allow_bypass_payment_method',
        isEligible: 'exclusive.is_eligible',
        exclusiveId: 'exclusive.id',
        templateId: 'template.id',
      },
    },
  },
  VENUE_SCHEMA: {
    FINDER: {
      activeNotifications: {
        _modifier: [
          {
            fn: Modifiers.arrayToDictionary,
            key: 'service_type_id',
          },
        ],
        breadcrumbs: 'notifies',
      },
      allowCardBypass: 'allow_bypass_payment_method',
      availableServiceTypes: {
        _modifier: Modifiers.dictionaryToArray,
        breadcrumbs: 'venue.service_types',
      },
      averagePriceStr: 'venue.ticket.average_str',
      collections: 'venue.collections',
      cuisine: 'venue.type',
      currencyDict: 'venue.currency',
      currency: 'venue.currency_symbol',
      events: 'venue.events',
      favorite: 'venue.favorite',
      gdaConciergeBooking: 'venue.gda_concierge_booking',
      id: 'venue.id.resy',
      images: {
        _modifier: [
          {
            fn: Modifiers.getFromSource,
            needsSource: true,
            key: 'templates',
          },
          {
            fn: Modifiers.get,
            key: 'images',
          },
        ],
        breadcrumbs: 'venue.default_template',
      },
      isGda: 'is_global_dining_access',
      location: {
        code: 'venue.location.code',
        urlSlug: 'location.url_slug',
        neighborhood: 'venue.location.neighborhood',
        name: 'venue.location.name',
      },
      name: 'venue.name',
      priceRange: 'venue.price_range',
      rating: 'venue.rating',
      reopen: 'venue.reopen',
      responsiveImages: 'venue.responsive_images',
      source: 'venue.source',
      totalRatings: 'venue.total_ratings',
      urlSlug: 'venue.url_slug',
      whyWeLikeIt: {
        _modifier: Modifiers.getWhyWeLikeIt,
        breadcrumbs: 'content',
      },
      transactionProcessor: 'venue.transaction_processor',
    },
    INVITE: {
      config: 'config',
      contact: {
        phone: {
          _modifier: Modifiers.formatPhone,
          breadcrumbs: 'contact.phone_number',
        },
        url: 'contact.url',
      },
      id: 'id',
      location: {
        address1: 'location.address_1',
        address2: 'location.address_2',
        coords: {
          lat: 'location.latitude',
          long: 'location.longitude',
        },
        city: 'location.locality',
        state: 'location.region',
        postalCode: 'location.postal_code',
      },
      name: 'name',
      social: 'social',
    },
    LIST_VENUES: {
      id: 'id.resy',
      name: 'name',
      location: {
        code: 'location.id',
        urlSlug: 'location.url_slug',
        neighborhood: 'location.neighborhood',
        city: 'location.locality',
        state: 'location.region',
      },
      urlSlug: 'url_slug',
    },
    VENUE: {
      announcement: 'announcement',
      averagePriceStr: 'ticket.average_str',
      enableDiscovery: 'config.enable_discovery',
      allowCardBypass: 'allow_bypass_payment_method',
      platinumNight: 'platinum_night',
      collections: 'collections',
      contact: {
        phone: {
          _modifier: Modifiers.formatPhone,
          breadcrumbs: 'contact.phone_number',
        },
        url: 'contact.url',
        menuUrl: 'contact.menu_url',
      },
      content: 'content',
      cuisine: 'type',
      currencyDict: 'currency',
      currency: 'currency_symbol',
      favorite: 'favorite',
      id: 'id.resy',
      fb_pixel: 'id.fb_pixel',
      featureRecaptcha: 'feature_recaptcha',
      gdaConciergeBooking: 'gda_concierge_booking',
      images: 'images',
      isMobileFirstLogin: 'user_login_preference.mobile_first',
      isGda: 'is_global_dining_access',
      isGdaOnly: 'is_global_dining_access_only',
      isResyCreditEligible: 'is_resy_credit_eligible',
      isUSLocation: {
        _modifier: Modifiers.isUSLocation,
        breadcrumbs: 'location.country',
      },
      name: 'name',
      largePartyMessage: 'large_party_message',
      locale: 'locale',
      location: {
        address1: 'location.address_1',
        address2: 'location.address_2',
        code: 'location.code',
        coords: {
          lat: 'location.latitude',
          long: 'location.longitude',
        },
        neighborhood: 'location.neighborhood',
        city: 'location.locality',
        state: 'location.region',
        postalCode: 'location.postal_code',
        country: 'location.country',
        urlSlug: 'location.url_slug',
      },
      maxPartySize: 'max_party_size',
      metadata: {
        description: 'metadata.description',
      },
      minPartySize: 'min_party_size',
      priceRange: 'price_range_id',
      rater: 'rater',
      reopen: 'reopen',
      responsiveImages: 'responsive_images',
      resySelect: 'resy_select',
      safety_info_url: 'safety_info_url',
      safetyInfoUrl: 'safety_info_url',
      safetyCategories: 'safety_categories',
      showRecommendations: 'show_recommendations',
      social: 'social',
      source: 'source',
      taxIncluded: 'tax_included',
      transactionProcessor: 'transaction_processor',
      urlSlug: 'url_slug',
      customAffiliation: 'custom_affiliation',
      customAffiliations: 'custom_affiliations',
      venueGroup: {
        id: 'venue_group.id',
        name: 'venue_group.name',
        venues: 'venue_group.venues',
      },
    },
  },

  SURVEY_SCHEMA: {
    QUESTION: {
      id: 'id',
      order: 'order',
      questionsetId: 'questionset_id',
      category: {
        value: 'category.value',
        displayOrder: 'category.display_order',
      },
      type: {
        id: 'id',
        value: 'value',
      },
      question: 'question',
      characterMinimum: 'character_minimum',
      helpText: 'help_text',
      leftLabel: 'left_label',
      rightLabel: 'right_label',
      options: [{
        id: 'option.id',
        text: 'option.text',
        value: 'option.value',
        order: 'option.order',
      }],
    },
  },
};
